import styled from 'styled-components';

export const Bar = styled.nav`
width:98%;
height: 55px;
background-color: white;
text-align:centre;
display:flex;
align-items: center;
padding:1vw;
box-shadow:0px 0.1vw 1vw #5c5c5c;
margin-bottom:1.5vw;
`

export const HambIcon = styled.img`
height:30px;
margin:1vw;
cursor:pointer;
`

export const ImgContainer =styled.span`
border: 0px solid red;
`
export const Logo_img =styled.img`
width:129.8 px;
margin:auto;
height:55px;
border:0px solid red;
margin-left:40vw;
`
